import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import profPlaceholder from "../../../img/profile-placeholder.png";
import "../styles/adminStyles.css";
import EditUserDetailsModal from "./EditUserDetailsModal";
import userActions from "../../../_actions/userActions";

export default function AdminUsersDetails(props) {
  const { tabId, userId } = props;

  const dispatch = useDispatch();

  const user = useSelector((state) => state.users.openUserDetails[userId] || null);
  const userRoles = useSelector((state) => state.users.userRoles || null);
  const unitList = useSelector((state) => state.users.openUnitLists[tabId] || null);

  useEffect(() => dispatch(userActions.getInfoById(userId, tabId)), [userId]);

  const [showModal_editUserDetails, setShowModal_editUserDetails] = useState(false);
  const toggleModal_editUserDetails = () =>
    setShowModal_editUserDetails(!showModal_editUserDetails);

  return (
    <React.Fragment>
      {user ? (
        <React.Fragment>
          <h3>{user.fullName}</h3>
          <h5 className="text-muted">
            {user.userRole ? user.userRole.description : "(No Classification)"}
          </h5>
        </React.Fragment>
      ) : (
        <h5>No user selected</h5>
      )}
      {user && (
        <React.Fragment>
          <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
            <li className="list-group-item py-1 pl-1">
              <div className="row">
                <div className="col pr-1">
                  <b>Employee ID:</b>
                </div>
                <div className="col pl-1">{user.employeeNo}</div>
              </div>
            </li>
            <li className="list-group-item py-1 pl-1">
              <div className="row">
                <div className="col pr-1">
                  <b>Unit:</b>
                </div>
                <div className="col pl-1">{user.unit.distUnit}</div>
              </div>
            </li>
            <li className="list-group-item py-1 pl-1">
              <div className="row">
                <div className="col pr-1">
                  <b>Phone:</b>
                </div>
                <div className="col pl-1">{user.phoneNumber || "(N/A)"}</div>
              </div>
            </li>
            <li className="list-group-item py-1 pl-1">
              <div className="row">
                <div className="col pr-1">
                  <b>Email:</b>
                </div>
                <div className="col pl-1">{user.email || "(N/A)"}</div>
              </div>
            </li>
            <li className="list-group-item py-1 pl-1">
              <b>Photo:</b>
              <br />
              <img
                src={profPlaceholder}
                alt="Profile Placeholder"
                className="profile-photo"
              />
            </li>
          </ul>
          <button
            type="button"
            name="editUser"
            id="editUser"
            className="btn btn-sm btn-secondary"
            onClick={toggleModal_editUserDetails}
          >
            Edit User...
          </button>
          {showModal_editUserDetails && (
            <EditUserDetailsModal
              showModal={showModal_editUserDetails}
              toggleModal={toggleModal_editUserDetails}
              tabId={tabId}
              user={user}
              isNewUserRegistration={false}
              allowRegisterAsOfficeAdmin={true}
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
